import { DeclarationHome } from "../Declaration/DeclarationHome";

const HomePage: React.FC = () => {
  return <DeclarationHome />;
};

export { HomePage };
